import React from 'react'

const IconBox = () => {
  return (
    <>
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="st-iconbox st-style1">
            <div class="st-iconbox-icon">
              <svg viewBox="0 0 512 512">
                <g>
                  <path d="m336 144a8 8 0 0 0 -8 8v104a8 8 0 0 0 16 0v-104a8 8 0 0 0 -8-8z" />
                  <path d="m336 272a8 8 0 0 0 -8 8v8a8 8 0 0 0 16 0v-8a8 8 0 0 0 -8-8z" />
                  <path
                    d="m496 24h-480a8 8 0 0 0 -8 8v352a8 8 0 0 0 8 8h288v64a32 32 0 0 0 64 0v-64h48a8.008 8.008 0 0 0 5.66-2.34l80-80a8.008 8.008 0 0 0 2.34-5.66v-272a8 8 0 0 0 -8-8zm-144 432a16 16 0 0 1 -32 0v-16h32zm0-32h-32v-8h32zm0-24h-32v-264h32zm0-280h-32v-6.11l.94-1.89h30.12l.94 1.89zm-23.06-24 7.06-14.11 7.06 14.11zm95.06 268.69v-52.69h52.69zm64-68.69h-72a8 8 0 0 0 -8 8v72h-40v-264a8.081 8.081 0 0 0 -.84-3.58l-24-48a8.009 8.009 0 0 0 -14.32 0l-24 48a8.081 8.081 0 0 0 -.84 3.58v264h-280v-336h464z" />
                  <path d="m48 72h72a8 8 0 0 0 0-16h-72a8 8 0 0 0 0 16z" />
                  <path d="m80 88a8 8 0 0 0 -8-8h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 8-8z" />
                  <path
                    d="m288 88a104.118 104.118 0 0 0 -104 104 8 8 0 0 0 16 0 88.1 88.1 0 0 1 88-88 8 8 0 0 0 0-16z" />
                  <path
                    d="m240 184a8 8 0 0 0 -8 8 80.091 80.091 0 0 1 -80 80 8 8 0 0 0 0 16 96.108 96.108 0 0 0 96-96 8 8 0 0 0 -8-8z" />
                  <path
                    d="m456 192a8 8 0 0 0 16 0 80.091 80.091 0 0 0 -80-80 8 8 0 0 0 0 16 64.072 64.072 0 0 1 64 64z" />
                  <path
                    d="m168 216a48 48 0 1 0 -48 48 48.053 48.053 0 0 0 48-48zm-48 32a32 32 0 1 1 32-32 32.036 32.036 0 0 1 -32 32z" />
                  <path
                    d="m264 288a24 24 0 1 0 24 24 24.028 24.028 0 0 0 -24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1 -8 8z" />
                  <path
                    d="m432 112a24 24 0 1 0 -24-24 24.028 24.028 0 0 0 24 24zm0-32a8 8 0 1 1 -8 8 8.009 8.009 0 0 1 8-8z" />
                </g>
              </svg>
            </div>
            <h2 class="st-iconbox-title">Web Development</h2>
            <div class="st-iconbox-text">
            The complexity of web development may vary depending on the extent of the project. 
            There are various web development frameworks, content management systems, 
            and tools readily accessible to enhance the efficiency and  the development process.
              </div>
          </div>
          <div class="st-height-b30 st-height-lg-b30"></div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="st-iconbox st-style1">
            <div class="st-iconbox-icon">
              <svg viewBox="0 0 512 512">
                <g>
                  <g>
                    <path d="M360,104h-80c-4.418,0-8,3.582-8,8v80c0,4.418,3.582,8,8,8h80c4.418,0,8-3.582,8-8v-80C368,107.582,364.418,104,360,104z
                  M288,184v-52.693L340.693,184H288z M352,172.68L299.32,120H352V172.68z" />
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M360,216h-80c-4.418,0-8,3.582-8,8v80c0,4.418,3.582,8,8,8h80c4.418,0,8-3.582,8-8v-80C368,219.582,364.418,216,360,216z
                  M288,296v-52.685L340.685,296H288z M352,284.688L299.312,232H352V284.688z" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="272" y="328" width="64" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="352" y="328" width="16" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="272" y="360" width="96" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="272" y="392" width="96" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="136" y="184" width="80" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="136" y="248" width="80" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="136" y="312" width="80" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M464,56c-4.418,0-8,3.582-8,8v32h-48V16c0-8.837-7.163-16-16-16H120c-8.837,0-16,7.163-16,16v80H56V64
                 c0-4.418-3.582-8-8-8c-0.48,0-48,0.728-48,64v312c0,30.504,30.4,44.632,46.4,47.84c0.526,0.111,1.062,0.165,1.6,0.16h56v16
                 c0,8.837,7.163,16,16,16h272c8.837,0,16-7.163,16-16v-16h56c0.538,0.005,1.074-0.049,1.6-0.16c16-3.208,46.4-17.336,46.4-47.84
                 V120C512,56.728,464.48,56,464,56z M16,120c0-32.64,14.4-43.088,24-46.4v312.232c-8.773,2.722-16.927,7.139-24,13V120z M104,464
                 H48.88C44.104,462.856,16,455.128,16,432c0-24.96,32.248-31.88,33.6-32.16c3.725-0.76,6.401-4.038,6.4-7.84V112h48V464z M120,88
                 h92.12L120,145.543V88z M232,94.447V152h-92.136L232,94.447z M120,168h112v48H120V168z M120,232h112v48H120V232z M120,296h112v48
                 H120V296z M120,360h94.186L120,424.724V360z M232,367.172V432h-94.337L232,367.172z M392,496H120v-48h272V496z M392,432H248V88
                 h144V432z M392,72H120V16h272V72z M463.136,464H408V112h48v280c-0.001,3.802,2.675,7.08,6.4,7.84
                 c0.368,0.072,33.6,7.008,33.6,32.16C496,455.256,468.072,462.84,463.136,464z M496,398.832c-7.073-5.861-15.227-10.278-24-13V73.6
                 c9.496,3.32,24,13.776,24,46.4V398.832z" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="200" y="40" width="64" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="280" y="40" width="16" height="16" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect x="312" y="40" width="16" height="16" />
                  </g>
                </g>
              </svg>
            </div>
            <h2 class="st-iconbox-title">Web Maintenance</h2>
            <div class="st-iconbox-text">
            Ongoing maintenance and updates are essential for websites, encompassing bug fixes, 
            security updates, and content updates. Consistent monitoring and timely updates play 
            a crucial role in ensuring the website's security. 
            </div>
          </div>
          <div class="st-height-b30 st-height-lg-b30"></div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="st-iconbox st-style1">
            <div class="st-iconbox-icon">
              <svg viewBox="0 0 64 64">
                <path
                  d="m62.618 45-5-10h-1.618v-34h-14v34h-19v-17.217l-4.676-10.286c-.413-.909-1.325-1.497-2.324-1.497s-1.911.588-2.324 1.496l-4.676 10.287v17.217h-2.618l-5 10h5.618v18h50v-18zm-18.618-14h6v-2h-6v-2h4v-2h-4v-2h6v-2h-6v-2h4v-2h-4v-2h6v-2h-6v-2h4v-2h-4v-2h6v-2h-6v-2h10v32h-10zm12.382 6 3 6h-21.764l-3-6zm-39.387-2v-15.132l2.002 1.333 2.003-1.334v15.133zm3.743-17.361-1.741 1.159-3.002-2.001-2.998 2-1.735-1.158 1.654-3.639h6.167zm-5.242-9.316c.18-.393.828-.394 1.008.001l1.67 3.676h-4.349zm-4.496 11.547 1.997 1.333 1.998-1.333v15.13h-3.995zm-3.382 17.13h21.764l-3 6h-21.764zm1.382 8h18.618l3.382-6.764v22.764h-22zm46 16h-22v-22.764l3.382 6.764h18.618z" />
                <path d="m19 57h2v2h-2z" />
                <path d="m11 57h2v2h-2z" />
                <path d="m15 57h2v2h-2z" />
                <path d="m11 53h10v2h-10z" />
                <path
                  d="m28 9.657c0-1.465 1.192-2.657 2.657-2.657h.686c1.465 0 2.657 1.192 2.657 2.657 0 .709-.276 1.376-.778 1.879l-5.222 5.222v8.242h6v-5.758l3.464-3.464c1.636-1.635 2.536-3.809 2.536-6.121 0-4.773-3.884-8.657-8.657-8.657h-.686c-4.773 0-8.657 3.884-8.657 8.657v2.343h6zm-2 0v.343h-2v-.343c0-3.671 2.986-6.657 6.657-6.657h.686c3.671 0 6.657 2.986 6.657 6.657 0 1.777-.692 3.449-1.95 4.707l-4.05 4.05v4.586h-2v-5.414l4.637-4.636c.879-.881 1.363-2.051 1.363-3.293 0-2.568-2.089-4.657-4.657-4.657h-.686c-2.568 0-4.657 2.089-4.657 4.657z" />
                <path
                  d="m28 30c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3zm4 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1z" />
              </svg>
            </div>
            <h2 class="st-iconbox-title">Back-end Development</h2>
            <div class="st-iconbox-text">
            Backend development involves creating the server-side logic and infrastructure 
            that powers a website or application's functionality, database management, and integrations.
            </div>
          </div>
          <div class="st-height-b30 st-height-lg-b30">

          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="st-iconbox st-style1">
            <div class="st-iconbox-icon">
              <svg viewBox="0 0 512 512">
                <g>
                  <path d="M216,456H160a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Z" />
                  <path d="M248,456h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z" />
                  <path
                    d="M442.68,363.48,392,312.8V165.27l22.4-22.4a7.953,7.953,0,0,0,1.93-3.13L433.3,88.82A8,8,0,0,0,423.18,78.7L392,89.09V40A32.042,32.042,0,0,0,360,8H152a32.042,32.042,0,0,0-32,32V86.53L69.32,137.21a8,8,0,0,0,0,11.31L120,199.2V346.74L80.63,386.11A32.005,32.005,0,0,0,120,436.01V472a32.042,32.042,0,0,0,32,32H360a32.042,32.042,0,0,0,32-32V425.47l50.68-50.68A8,8,0,0,0,442.68,363.48ZM413.06,98.94l-4.99,14.97-9.98-9.98Zm-31.95,10.64,21.31,21.31-.67,2-4.32,4.32-22.64-22.64,4.32-4.32ZM306.92,227.72l-5.66-5.66,67.88-67.88a8,8,0,1,0-11.32-11.32l-67.88,67.88-5.66-5.65,79.2-79.2,22.63,22.64-7.74,7.74-.05.05ZM376,181.27V296.8l-57.76-57.76ZM293.44,24l-4.5,16H222.25l-4-16ZM136,40a16.021,16.021,0,0,1,16-16h49.75l6.49,25.94A8,8,0,0,0,216,56h79a8,8,0,0,0,7.7-5.83L310.06,24H360a16.021,16.021,0,0,1,16,16V94.42l-3.74,1.25a7.953,7.953,0,0,0-3.13,1.93l-96.16,96.17L148.52,69.32a8,8,0,0,0-11.31,0L136,70.53ZM114.59,420.05a16.005,16.005,0,1,1-22.64-22.63l11.31-11.32,22.64,22.64Zm-.01-45.26,5.66-5.65,22.62,22.62-5.65,5.66Zm90.51-90.5,22.63,22.63-73.54,73.54-22.63-22.64ZM136,330.74V215.2l57.77,57.77ZM376,472a16.021,16.021,0,0,1-16,16H152a16.021,16.021,0,0,1-16-16V421.26L239.04,318.24,363.48,442.68a8,8,0,0,0,11.31,0l1.21-1.21Zm-6.86-46.29-22.63-22.63,5.66-5.66a8,8,0,0,0-11.32-11.31l-5.65,5.65-11.32-11.31,16.97-16.97a8,8,0,0,0-11.31-11.31l-16.97,16.97-11.32-11.32,5.66-5.65a8,8,0,0,0-11.31-11.32l-5.66,5.66L278.63,335.2l16.97-16.97a8,8,0,0,0-11.32-11.32l-16.97,16.97L256,312.57l5.66-5.66a8,8,0,1,0-11.32-11.31l-5.65,5.65a.035.035,0,0,1-.02-.01l-11.3-11.3,16.97-16.97a8,8,0,0,0-11.31-11.31l-16.97,16.97-11.29-11.29c-.01-.01-.01-.02-.02-.03l5.65-5.65a8,8,0,1,0-11.31-11.32L199.43,256l-11.31-11.31,16.97-16.97a8,8,0,0,0-11.32-11.32L176.8,233.37l-11.31-11.31,5.66-5.66a8,8,0,0,0-11.32-11.31l-5.65,5.66-11.32-11.32,16.97-16.97a8,8,0,0,0-11.31-11.31l-16.97,16.97L120.24,176.8l5.65-5.65a8,8,0,0,0-11.31-11.32l-5.66,5.66L86.29,142.86l39.6-39.59L408.73,386.11Zm50.91-50.92L137.21,91.95l5.65-5.66L267.29,210.72c.01.01.01.02.02.03s.02.01.03.02l16.93,16.94c.01,0,.01,0,.01.01s.01,0,.01.01l16.95,16.94c.01.01.01.02.02.03s.02.01.03.02l77.02,77.02a.234.234,0,0,0,.07.07l47.33,47.33Z" />
                </g>
              </svg>
            </div>
            <h2 class="st-iconbox-title">Payment Gateway Integration</h2>
            <div class="st-iconbox-text">
            A payment gateway is a service that allows businesses to securely accept online payments from customers. 
            It acts as the intermediary between the website and the financial institution, facilitating the transfer of funds.
            </div>
          </div>
          <div class="st-height-b0 st-height-lg-b30"></div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="st-iconbox st-style1">
            <div class="st-iconbox-icon">
              <svg viewBox="0 0 512 512">
                <path
                  d="m48 496h416a32.036 32.036 0 0 0 32-32v-416a32.036 32.036 0 0 0 -32-32h-416a32.036 32.036 0 0 0 -32 32v416a32.036 32.036 0 0 0 32 32zm-16-32h32v16h-16a16.01833 16.01833 0 0 1 -16-16zm128-48h-80v-16h80zm0 16v16h-80v-16zm0 32v16h-80v-16zm0-80h-80v-16h80zm-32-32h-96v-176h96zm-64 16v16h-32v-16zm0 32v16h-32v-16zm0 32v16h-32v-16zm400 48h-288v-112h304v96a16.01833 16.01833 0 0 1 -16 16zm16-432v304h-336v-320h320a16.01833 16.01833 0 0 1 16 16zm-432-16h80v128h-96v-112a16.01833 16.01833 0 0 1 16-16z" />
                <path d="m208 384h104v16h-104z" />
                <path d="m288 416h144v16h-144z" />
                <path d="m248 448h48v16h-48z" />
                <path d="m320 448h24v16h-24z" />
                <path d="m376 384h56v16h-56z" />
                <circle cx="56" cy="56" r="8" />
                <circle cx="80" cy="56" r="8" />
                <circle cx="104" cy="56" r="8" />
                <path d="m384 312h80v16h-80z" />
                <path
                  d="m332.68652 328 5.65674 5.65674a7.99945 7.99945 0 0 0 11.31348 0l16-16a7.99877 7.99877 0 0 0 2.34326-5.65674v-24a7.99977 7.99977 0 0 0 -8-8h-32a7.99977 7.99977 0 0 0 -8 8v24h-160v16zm3.31348-32h16v12.68652l-8 8-8-8z" />
                <path d="m48 192h48v16h-48z" />
                <path d="m48 224h32v16h-32z" />
                <path d="m48 256h48v16h-48z" />
                <path d="m80 288h32v16h-32z" />
                <path d="m80 320h32v16h-32z" />
                <path
                  d="m210.66455 253.96094a8.00168 8.00168 0 0 0 6.21875 1.99023l72-8a7.99845 7.99845 0 0 0 4.77344-2.29443l29.65674-29.65674h19.24267l-6.44726 38.68457a7.99969 7.99969 0 0 0 4.31347 8.4707l16 8a8 8 0 0 0 10.93067-4.0039l20.14258-46.99951a33.75475 33.75475 0 0 0 -25.47608-46.59229l-17.37036-2.895 10.66483-10.66457h36.686a7.99948 7.99948 0 0 0 4.7998-1.6001l32-24a7.9996 7.9996 0 0 0 2.35547-9.97754l-8-16a7.99877 7.99877 0 0 0 -9.0957-4.18359l-29.49023 7.37256-25.2182-10.08716a23.96392 23.96392 0 0 0 .64886-5.52417v-27.05566a20.94358 20.94358 0 0 0 -30.31055-18.73291l-13.26709 6.6333a7.99924 7.99924 0 0 0 -4.42236 7.15527v24h-32a8.00164 8.00164 0 0 0 -2.97119.57227l-40 16a7.99975 7.99975 0 0 0 -5.02881 7.42773v16a7.99977 7.99977 0 0 0 8 8h45.75391l-5.36005 21.43921-22.33186 52.10718-44.5918 14.86425a8.00011 8.00011 0 0 0 -5.4702 7.58936v16a8.00089 8.00089 0 0 0 2.66455 5.96094zm162.64945-52.72022a17.73543 17.73543 0 0 1 -.52441 12.60791l-16.80078 39.20166-3.12647-1.56347 7.02881-42.17139a8.00034 8.00034 0 0 0 -7.89115-9.31543h-40.92871a20.1611 20.1611 0 0 1 -19.12647-26.53662l.96155-2.88464 32.12244 12.849a7.986 7.986 0 0 0 1.65729.45722l-.001.00616 32.7041 5.45069a17.7145 17.7145 0 0 1 13.9248 11.89891zm-21.314-57.24072a7.99877 7.99877 0 0 0 -5.65674 2.34326l-20.27 20.26953-28.61865-11.44726 6.30664-25.2251a8.0001 8.0001 0 0 0 -7.76125-9.94043h-8v-16h25.3761a23.97964 23.97964 0 0 0 37.033 11.17987l26.82165 10.72864 4.52291 18.09149zm-8-48a8 8 0 0 1 -16 0v-8h16zm69.85889 29.606-17.01984 12.76489-3.13751-12.55 18.01282-4.50348zm-77.01319-61.084a4.94339 4.94339 0 0 1 7.1543 4.42234v3.05566h-16v-3.05566zm-88.8457 52.8945 24-9.60022v12.18372h-24zm-24 120.34961 42.52979-14.17675a7.99955 7.99955 0 0 0 4.82324-4.438l8.81164-20.56055c.26654.43829.53235.877.81873 1.30664a36.07631 36.07631 0 0 0 20.894 14.91168l-17.54974 17.54975-60.32766 6.70312z" />
              </svg>
            </div>
            <h2 class="st-iconbox-title">Web Hosting</h2>
            <div class="st-iconbox-text">
            Choosing a Web Hosting Provider need to select a 
            reliable web hosting provider that meets their requirements. 
            Factors to consider include server performance,
            security, customer support, pricing, and scalability
            </div>
          </div>
          <div class="st-height-b0 st-height-lg-b30"></div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="st-iconbox st-style1">
            <div class="st-iconbox-icon">
              <svg viewBox="0 0 512 512">
                <g id="XMLID_1568_">
                  <g id="XMLID_652_">
                    <path id="XMLID_676_"
                      d="m482 278h-37.673v-54c0-14.602-10.489-26.795-24.327-29.455v-104.529c0-19.859-16.157-36.016-36.017-36.016h-128.983c-5.522 0-10 4.477-10 10s4.478 10 10 10h128.983c8.832 0 16.017 7.185 16.017 16.016v103.984h-129.667c-16.542 0-30 13.458-30 30v63.228h-220.333v-197.212c0-8.831 7.185-16.016 16.017-16.016h128.983c5.522 0 10-4.477 10-10s-4.478-10-10-10h-128.983c-19.86 0-36.017 16.157-36.017 36.016v229.268c0 19.859 16.157 36.017 36.017 36.017h123.33v36.063c0 19.688-9.953 37.694-26.624 48.168-3.774 2.371-5.523 6.953-4.29 11.235 1.233 4.283 5.152 7.232 9.609 7.232h343.958c16.542 0 30-13.458 30-30v-119.999c0-16.542-13.458-30-30-30zm-211.667-64h143.994c5.514 0 10 4.486 10 10v54h-14.327c-16.542 0-30 13.458-30 30v120c0 3.506.61 6.87 1.72 10h-111.387c-5.514 0-10-4.486-10-10v-204c0-5.514 4.486-10 10-10zm-250.333 105.284v-12.057h220.333v28.073h-70.986-133.33c-8.832.001-16.017-7.184-16.017-16.016zm159.347 72.08v-36.063h60.986v72.699c0 3.506.61 6.87 1.72 10h-78.402c10.071-13.169 15.696-29.427 15.696-46.636zm312.653 36.636c0 5.514-4.486 10-10 10h-72c-5.514 0-10-4.486-10-10v-120c0-5.514 4.486-10 10-10h72c5.514 0 10 4.486 10 10z" />
                    <path id="XMLID_1626_"
                      d="m58 114.614c-5.522 0-10 4.477-10 10v112c0 5.523 4.478 10 10 10h88c5.522 0 10-4.477 10-10v-112c0-5.523-4.478-10-10-10zm78 112h-68v-92h68z" />
                    <path id="XMLID_1627_"
                      d="m194 134.614h101c5.522 0 10-4.477 10-10s-4.478-10-10-10h-101c-5.522 0-10 4.477-10 10s4.478 10 10 10z" />
                    <path id="XMLID_1628_"
                      d="m194 230.61c2.63 0 5.21-1.06 7.069-2.92 1.86-1.87 2.931-4.44 2.931-7.08 0-2.63-1.07-5.21-2.931-7.07-1.859-1.86-4.439-2.93-7.069-2.93s-5.21 1.07-7.07 2.93-2.93 4.44-2.93 7.07 1.069 5.21 2.93 7.08c1.86 1.86 4.44 2.92 7.07 2.92z" />
                    <path id="XMLID_1639_"
                      d="m194 182.614h37.5c5.522 0 10-4.477 10-10s-4.478-10-10-10h-37.5c-5.522 0-10 4.477-10 10s4.478 10 10 10z" />
                    <path id="XMLID_1674_"
                      d="m446 398c-2.63 0-5.21 1.069-7.07 2.93s-2.93 4.44-2.93 7.07 1.069 5.21 2.93 7.069c1.86 1.86 4.44 2.931 7.07 2.931s5.21-1.07 7.069-2.931c1.861-1.859 2.931-4.439 2.931-7.069s-1.07-5.21-2.931-7.07c-1.859-1.861-4.439-2.93-7.069-2.93z" />
                    <path id="XMLID_1677_"
                      d="m342.33 418c2.63 0 5.21-1.07 7.069-2.931 1.86-1.859 2.931-4.439 2.931-7.069s-1.07-5.21-2.931-7.07c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21 1.069-7.07 2.93-2.93 4.44-2.93 7.07 1.069 5.21 2.93 7.069c1.86 1.861 4.44 2.931 7.07 2.931z" />
                    <path id="XMLID_1681_"
                      d="m210 74c2.63 0 5.21-1.07 7.069-2.93 1.861-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21 1.07-7.07 2.93-2.93 4.44-2.93 7.07 1.069 5.21 2.93 7.07 4.44 2.93 7.07 2.93z" />
                  </g>
                </g>
              </svg>
            </div>
            <h2 class="st-iconbox-title">Responsive Design</h2>
            <div class="st-iconbox-text">
            Responsive design is an approach to web design that ensures websites and applications adapt to different screen sizes and devices for optimal user experience.
            </div>
          </div>
          <div class="st-height-b0 st-height-lg-b30"></div>
        </div>
      </div>
    </div>
    <div class="st-height-b100 st-height-lg-b80"></div>

  <section class="st-dark-bg">
    <div class="st-height-b100 st-height-lg-b80"></div>
    <div class="container">
      <div class="st-section-heading st-style1">
        <h4 class="st-section-heading-title">MY SKILLS</h4>
        <h2 class="st-section-heading-subtitle">MY SKILLS</h2>
      </div>
      <div class="st-height-b25 st-height-lg-b25"></div>
    </div>
    </section>
    </>
  )
}

export default IconBox
